// Cache de l'última resposta vàlida de ControlHorariEstat.php, per poder
// carregar la interfície bàsica sense connexió (CURRENT_TASK.md §10, §15):
// sense això, si l'Empleat obre l'app sense xarxa, no tindria ni l'Horari
// previst ni els Tipus de pausa disponibles per fitxar una pausa offline.
// S'utilitza localStorage (dades petites i no sensibles, no és la cua
// d'events, que va sempre a IndexedDB).

const KEY = "ch_ultimEstatServidor";

export function chDesarEstatCache(estat) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ estat, guardatEn: new Date().toISOString() }));
  } catch {
    // localStorage ple/no disponible: no és crític, simplement no hi haurà cache.
  }
}

export function chLlegirEstatCache() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
